import { Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { expandTheme } from 'utils/theme-util';
import { combineStyles } from 'services/utils/styles-service';
import { BaseTableStyles } from '../base-table/base-table.styles';

export const TableStyles = (theme: Theme) => {
  const { font, palette } = expandTheme(theme);

  return createStyles({
    expansionHeader: {
      paddingTop: theme.spacing(1.5),
      paddingLeft: theme.spacing(1),
    },
    expansionHeaderTextLeft: {
      fontSize: font.largeFontSize,
      fontWeight: 'bold',
      color: palette.primary.steelGrey,
      paddingLeft: theme.spacing(1),
    },
    expansionHeaderTextRight: {
      fontSize: font.smallFontSize,
      color: palette.primary.steelGrey,
      paddingTop: theme.spacing(1.2),
    },
    expansionHeaderExpandIcon: {
      marginLeft: theme.spacing(0.5),
    },
    expansionPanelStyles: {
      borderBottom: `1px solid ${palette.primary.grey1}`,
      boxShadow: theme.shadows[0],
    },
    expansionDetails: {
      padding: 0,
    },
    tableContainer: {
      marginTop: 0,
    },
  });
};

const styles = combineStyles(BaseTableStyles, TableStyles);
export const UseStyles = makeStyles(theme => styles(theme));
export { styles };
